const white = {
  active: '#F2F5F7',
  primary: '#FFFFFF',
};

const black = {
  primary: '#333333',
};

const blue = {
  hover: '#72BAFF',
  light: '#C9E1FF',
  active: '#006DC7',
  border: '#E6EDF6',
  primary: '#3E94FF',
  shadow06: '#3c4b670f',
  shadow10: '#7B91BF19',
  shadow16: '#7B91BF29',
  shadow20: '#7B91BF33',
  accent: { active: '#C8DCF7' },
  secondary: { hover: '#D6E9FF', active: '#B3D9FF', primary: '#ECF4FF' },
};

const gray = {
  dark: '#494D52',
  hover: '#E5E7EB',
  active: '#E5EAF0',
  primary: '#F3F4F6',
  neutral: '#9DA5B0',
  divider: '#D1DFEE',
};

const red = {
  primary: '#FD6460',
  secondary: { hover: '#FDDDDD', active: '#FCCCCB', primary: '#FFEFEF' },
};

const green = {
  primary: '#219603',
};

export const colors = {
  red,
  blue,
  gray,
  white,
  black,
  green,
};
